export default {
  data () {
    return {
    }
  },
  methods: {
    isValidEmail  (val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/
      return emailPattern.test(val) || 'Email não é válido'
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) {
        return ''
      }
      return value.toString().toUpperCase()
    },
    lowercase: function (value) {
      if (!value) {
        return ''
      }
      return value.toString().toLowerCase()
    }
  }
}
